<div class="relative flex flex-col w-full h-full">

    <!-- Content -->
    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">

        <!-- Icon -->
        <ng-container >
            <div
                class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600">
                <mat-icon
                    class="text-current"
                    [svgIcon]="'warning'"></mat-icon>
            </div>
        </ng-container>

        <ng-container>
            <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">

                <!-- Title -->
                <ng-container>
                    <div
                        class="text-xl leading-6 font-medium"
                        >
                    Account deactivated
                    </div>
                </ng-container>

                <!-- Message -->
                <ng-container>
                    <div
                        class="text-secondary"
                        >
                        Your account is deactivated and it will be logged out in {{counter}} second!
                    </div>
                </ng-container>
            </div>
        </ng-container>

    </div>

</div>
